import {
  Autocomplete,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import {
  useGetAssigneesMutation,
  useGetCountriesQuery,
  useGetSitesQuery,
  useLazyGetStudiesQuery
} from 'src/services/Utils';
import { useAppDispatch } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const AddandUpdateProtocolDeviation: React.FunctionComponent<any> = ({
  setCreateData,
  createData,
  updateData,
  edit,
  setUpdateData,
  category,
  severityPD,
  pdIdentification,
  analysis,
  initialState,
  submit,
  componentRef,
  atError,
  daError,
  duError,
  ddError,
  deviationLevel,
  deviationLogPermissions,
  setDisableSubmit
}) => {
  const [actionDateIssue, setActionDateIssue] = useState<boolean>(false);
  const [decisionDateIssue, setDecisionDateIssue] = useState<boolean>(false);
  const [irbReportDateIssue, setIrbReportDateIssue] = useState<boolean>(false);
  const [acDueDateIssue, setAcDueDateIssue] = useState<boolean>(false);
  const [dcDueDateIssue, setDcDueDateIssue] = useState<boolean>(false);
  const [pdIdenDateIssue, setPdIdenDateIssue] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { preferedFormatForDatePicker, userPreferedDateFormat } = usePreferedDateFormat();
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const { checkPermission } = usePermissionWrapper();
  const [studyRefetch, { data: studyData, isError: studyIsError }] = useLazyGetStudiesQuery();
  useEffect(() => {
    studyRefetch();
  }, []);
  const {
    data: countryData,
    isError: countryIsError,
    refetch: countryget
  } = useGetCountriesQuery(edit ? updateData.study_id : createData.study_id);
  const {
    data: siteData,
    isError: siteIsError,
    refetch: siteget
  } = useGetSitesQuery({
    currentStudy: edit ? updateData.study_id : createData.study_id,
    currentCountry: edit ? updateData.country : createData.country
  });
  const [studylist, setStudylist] = useState<any>([]);
  const [countrylist, setCountrylist] = useState<any>([]);
  const [sitelist, setSitelist] = useState<any>([]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
      }
    }
  };
  useEffect(() => {
    if (studyData && !studyIsError) {
      const tempArr = studyData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setStudylist(tempArr);
    } else {
      setStudylist([]);
    }
  }, [studyData, studyIsError]);
  useEffect(() => {
    if (countryData && !countryIsError) {
      const tempArr = countryData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setCountrylist(tempArr);
    } else {
      setCountrylist([]);
    }
  }, [countryData, countryIsError]);
  useEffect(() => {
    if (siteData && !siteIsError) {
      const tempArr = siteData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setSitelist(tempArr);
    } else {
      setSitelist([]);
    }
  }, [siteData, siteIsError]);

  const pdUpdatePermission = checkPermission(`update_${deviationLevel.toLowerCase()}_protocoldeviation`);
  const pdUpdateOtherPermission = checkPermission(`update_others_${deviationLevel.toLowerCase()}_protocoldeviation`);

  const actionAssignedTo = updateData.action_assigned_to.length <= 0;
  const decisionAssignedTo = updateData.decision_assigned_to.length <= 0;
  const issueCreatedUser = updateData.created_by;
  const { user, email } = useUser();
  const currentUserWithEmail = `${user} (${email})`;
  const filterActionUsers = actionAssignedTo
    ? updateData.action_assigned_to
    : updateData.action_assigned_to.filter((name: string) => name === currentUserWithEmail);
  const filterDecisionUsers = decisionAssignedTo
    ? updateData.decision_assigned_to
    : updateData.decision_assigned_to.filter((name: string) => name === currentUserWithEmail);

  const handleChange = (event: any) => {
    setDisableSubmit(false);
    if (edit) {
      setUpdateData({ ...updateData, [event.target.name]: event.target.value });
    } else {
      setCreateData({ ...createData, [event.target.name]: event.target.value });
    }
  };
  /**  functionality for toggling the checkbox */
  const handleCheckBoxChanged = (event: any) => {
    setDisableSubmit(false);
    if (edit) {
      if (event.target.checked) {
        setUpdateData({ ...updateData, [event.target.name]: 'Yes' });
      } else {
        if (event.target.name === 'reported_irb') {
          setUpdateData({ ...updateData, reported_irb: 'No', date_irb: null });
        } else if (event.target.name === 'action_req') {
          setUpdateData({
            ...updateData,
            [event.target.name]: 'No',
            action_des: '',
            action_taken: '',
            action_assigned_to: [],
            action_due: null,
            action_completion_dt: null
          });
        } else {
          setUpdateData({
            ...updateData,
            [event.target.name]: 'No',
            decision: '',
            decision_update: '',
            decision_assigned_to: [],
            decision_due_dt: null,
            decision_comp_dt: null
          });
        }
      }
    } else {
      if (event.target.checked) {
        setCreateData({ ...createData, [event.target.name]: 'Yes' });
      } else {
        if (event.target.name === 'reported_irb') {
          setCreateData({ ...createData, reported_irb: 'No', date_irb: null });
        } else if (event.target.name === 'action_req') {
          setCreateData({
            ...createData,
            [event.target.name]: 'No',
            action_des: '',
            action_taken: '',
            action_assigned_to: [],
            action_due: null,
            action_completion_dt: null
          });
        } else {
          setCreateData({
            ...createData,
            [event.target.name]: 'No',
            decision: '',
            decision_update: '',
            decision_assigned_to: [],
            decision_due_dt: null,
            decision_comp_dt: null
          });
        }
      }
    }
  };

  const [issueAssigne, setIssueAssigne] = useState<any>([]);
  const [decisionAssigne, setDecisionAssigne] = useState<any>([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  const [
    getDecisionAssignees,
    {
      data: decisionAssignees,
      isError: isDecisionAssingeeError,
      isSuccess: isDecisionAssingeeSuccess,
      isLoading: isDecisionAssingeeLoading
    }
  ] = useGetAssigneesMutation();

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = [];
      assignees.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name} (${item.email})`,
          displayName: `${item.first_name} ${item.last_name} (${item.email})`
        })
      );
      setIssueAssigne(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  useEffect(() => {
    if (!isDecisionAssingeeLoading && isDecisionAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isDecisionAssingeeLoading && isDecisionAssingeeSuccess && decisionAssignees) {
      const assignList: any = [];
      decisionAssignees.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name} (${item.email})`,
          displayName: `${item.first_name} ${item.last_name} (${item.email})`
        })
      );
      setDecisionAssigne(assignList);
    }
  }, [decisionAssignees, isDecisionAssingeeError, isDecisionAssingeeSuccess, isDecisionAssingeeLoading]);

  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: [`UPDATE_${deviationLevel}_PROTOCOLDEVIATION_ACTION`]
    });
    getDecisionAssignees({
      client_name: 'ctms-ui',
      data: [`UPDATE_${deviationLevel}_PROTOCOLDEVIATION_DECISION`]
    });
  }, []);

  const [initialStudy, setStudyInitial] = useState(false);
  const [initialCountry, setCountryInitial] = useState(false);
  useEffect(() => {
    if (initialStudy) {
      if (updateData.study_id === null) {
        updateData.country = null;
        updateData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (updateData.study_id) {
        updateData.country = null;
        updateData.site_id = null;
        countryget();
      }
      if (createData.study_id === null) {
        createData.country = null;
        createData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (createData.study_id) {
        initialState.study_id = null;
        initialState.country = null;
        initialState.site_id = null;
        createData.country = null;
        createData.site_id = null;
        countryget();
      }
    }
    setStudyInitial(true);
  }, [createData.study_id, updateData.study_id]);
  useEffect(() => {
    if (initialCountry) {
      if (createData.country === null) {
        createData.site_id = null;
      } else if (createData.country !== initialState.country) {
        createData.site_id = null;
        siteget();
      }
      if (updateData.country === null) {
        updateData.site_id = null;
        setSitelist([]);
      } else if (updateData.country !== initialState.country) {
        updateData.site_id = null;
        siteget();
      }
    }
    setCountryInitial(true);
  }, [createData.country, updateData.country]);

  const actionUsersList: any = [];
  issueAssigne?.map((data: any) => {
    actionUsersList.push(data.displayName);
  });

  const decisionUserList: any = [];
  decisionAssigne?.map((data: any) => {
    decisionUserList.push(data.displayName);
  });

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  return (
    <Grid container item rowSpacing={2} columnSpacing={5}>
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth>
          <TextField
            disabled
            name="deviation_no"
            label="Deviation Number"
            variant="standard"
            value={edit ? updateData.deviation_no : createData.deviation_no}
            inputProps={{
              maxLength: 100
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false}
        >
          <Autocomplete
            disabled={edit || deviationLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={studylist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, study_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, study_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.study_id : createData.study_id}
            renderInput={params => (
              <TextField
                error={submit ? createData.study_id === null : false}
                {...params}
                label="Study"
                className="alignFields"
              />
            )}
          />
          {(edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false) && (
            <FormHelperText>Required</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={edit || deviationLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={countrylist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, country: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, country: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.country : createData.country}
            renderInput={params => <TextField {...params} label="Country" className="alignFields" />}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={edit || deviationLevel == 'SITE'}
            disablePortal
            id="combo-box-demo"
            options={sitelist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, site_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, site_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.site_id : createData.site_id}
            renderInput={params => <TextField {...params} label="Site" className="alignFields" />}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <TextField
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission)
                : false
            }
            name="subject_id"
            label="Subject ID"
            variant="standard"
            value={edit ? updateData.subject_id : createData.subject_id}
            onChange={handleChange}
            required={updateData.site_id || createData.site_id ? true : false}
            error={
              updateData.site_id || createData.site_id
                ? edit
                  ? submit
                    ? updateData.subject_id === undefined || updateData.subject_id === ''
                    : false
                  : submit
                  ? createData.subject_id === undefined || createData.subject_id === ''
                  : false
                : false
            }
            helperText={
              updateData.site_id || createData.site_id
                ? (
                    edit
                      ? submit
                        ? updateData.subject_id === undefined || updateData.subject_id === ''
                        : false
                      : submit
                      ? createData.subject_id === undefined || createData.subject_id === ''
                      : false
                  )
                  ? 'Required'
                  : ''
                : null
            }
            inputProps={{
              maxLength: 50
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission)
                : false
            }
            inputFormat={dateFormat}
            label="Date of deviation identified"
            value={preferedFormatForDatePicker(edit ? updateData.dt_deviation : createData.dt_deviation)}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, dt_deviation: null });
                setUpdateData({ ...updateData, dt_deviation: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, dt_deviation: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, dt_deviation: getServerDateOrInvalid(newValue) });
              }
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setPdIdenDateIssue(true);
              } else {
                setPdIdenDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                required
                {...params}
                error={
                  (edit
                    ? submit
                      ? updateData.dt_deviation === undefined
                      : false
                    : submit
                    ? createData.dt_deviation === undefined
                    : false) || pdIdenDateIssue
                }
                helperText={
                  (
                    edit
                      ? submit
                        ? updateData.dt_deviation === undefined || updateData.dt_deviation === null
                        : false
                      : submit
                      ? createData.dt_deviation === undefined || createData.dt_deviation === null
                      : false
                  )
                    ? 'Required'
                    : pdIdenDateIssue
                    ? 'Invalid Date'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth>
          <TextField
            required
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission)
                : false
            }
            error={
              edit
                ? submit
                  ? updateData.deviation_des === undefined || updateData.deviation_des === ''
                  : false
                : submit
                ? createData.deviation_des === undefined || createData.deviation_des === ''
                : false
            }
            helperText={
              (
                edit
                  ? submit
                    ? updateData.deviation_des === undefined || updateData.deviation_des === ''
                    : false
                  : submit
                  ? createData.deviation_des === undefined || createData.deviation_des === ''
                  : false
              )
                ? 'Required'
                : ''
            }
            name="deviation_des"
            label="Protocol Deviation Description"
            variant="standard"
            value={edit ? updateData.deviation_des : createData.deviation_des}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={
            edit
              ? submit
                ? updateData.category === undefined
                : false
              : submit
              ? createData.category === undefined
              : false
          }
        >
          <InputLabel required id="demo-simple-select-standard-label">
            Category of Deviation
          </InputLabel>
          <Select
            MenuProps={menuProps}
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission)
                : false
            }
            labelId="demo-simple-select-standard-label"
            name="category"
            value={edit ? updateData.category : createData.category}
            onChange={handleChange}
            label="Category of Deviation"
          >
            {category?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {item.code_list_value}
                </MenuItem>
              );
            })}
          </Select>
          {(edit
            ? submit
              ? updateData.category === undefined
              : false
            : submit
            ? createData.category === undefined
            : false) && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl
          variant="standard"
          fullWidth
          error={
            edit
              ? submit
                ? updateData.severity === undefined
                : false
              : submit
              ? createData.severity === undefined
              : false
          }
        >
          <InputLabel required id="demo-simple-select-standard-label">
            Severity
          </InputLabel>
          <Select
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission)
                : false
            }
            labelId="demo-simple-select-standard-label"
            name="severity"
            value={edit ? updateData.severity : createData.severity}
            onChange={handleChange}
            label="Severity"
          >
            {severityPD?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {`${item.code_list_value_code}-${item.code_list_value}`}
                </MenuItem>
              );
            })}
          </Select>
          {(edit
            ? submit
              ? updateData.severity === undefined
              : false
            : submit
            ? createData.severity === undefined
            : false) && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          disabled={
            edit
              ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                (updateData.created_by !== user && !pdUpdateOtherPermission)
              : false
          }
          control={<Checkbox name="reported_irb" />}
          label="Reported to IRB/IEC?"
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
          checked={
            edit
              ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
              : createData.reported_irb === 'Yes'
          }
          onChange={handleCheckBoxChanged}
        />
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.reported_irb === 'No' ||
                  updateData.reported_irb === undefined ||
                  updateData.reported_irb === false
                : createData.reported_irb === 'No' || createData.reported_irb === undefined
            }
            inputFormat={dateFormat}
            label="IRB Report Date"
            value={preferedFormatForDatePicker(edit ? updateData.date_irb : createData.date_irb)}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setDisableSubmit(false);
                setCreateData({ ...createData, date_irb: null });
                setUpdateData({ ...updateData, date_irb: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, date_irb: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, date_irb: getServerDateOrInvalid(newValue) });
              }
              //IRB report date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setIrbReportDateIssue(true);
              } else {
                setIrbReportDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={
                  (edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                      ? submit
                        ? updateData.date_irb === undefined || updateData.date_irb === null
                        : false
                      : false
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                    ? submit
                      ? createData.date_irb === undefined || createData.date_irb === null
                      : false
                    : false) || irbReportDateIssue
                }
                helperText={
                  (
                    edit
                      ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                        ? submit
                          ? updateData.date_irb === undefined || updateData.date_irb === null
                          : false
                        : false
                      : createData.reported_irb === 'Yes' || createData.reported_irb === true
                      ? submit
                        ? createData.date_irb === undefined || createData.date_irb === null
                        : false
                      : false
                  )
                    ? 'Required'
                    : irbReportDateIssue
                    ? 'Invalid Date'
                    : ''
                }
                required={
                  edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          disabled={
            edit
              ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                (updateData.created_by !== user && !pdUpdateOtherPermission)
              : false
          }
          control={<Checkbox name="action_req" />}
          label="Action Required?"
          checked={
            edit ? updateData.action_req === 'Yes' || updateData.action_req === true : createData.action_req === 'Yes'
          }
          onChange={handleCheckBoxChanged}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            name="action_des"
            label="Action Description"
            variant="standard"
            value={edit ? updateData.action_des : createData.action_des}
            inputProps={{
              maxLength: 2000
            }}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mt={2}>
        <FormControl fullWidth>
          <TextField
            required={edit ? updateData.action_completion_dt : createData.action_completion_dt}
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  ((filterActionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !pdUpdateOtherPermission) ||
                  updateData.action_req === false ||
                  !(deviationLogPermissions.updateAction || deviationLogPermissions.updateOther)
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            error={
              (edit
                ? updateData.action_taken
                  ? false
                  : submit
                  ? updateData.action_completion_dt
                    ? true
                    : false
                  : false
                : createData.action_taken
                ? false
                : submit
                ? createData.action_completion_dt
                  ? true
                  : false
                : false) || atError
            }
            helperText={
              (
                edit
                  ? updateData.action_taken
                    ? false
                    : submit
                    ? updateData.action_completion_dt
                      ? true
                      : false
                    : false
                  : createData.action_taken
                  ? false
                  : submit
                  ? createData.action_completion_dt
                    ? true
                    : false
                  : false
              )
                ? 'Required'
                : ''
            }
            name="action_taken"
            label="Action Taken"
            variant="standard"
            value={edit ? updateData.action_taken : createData.action_taken}
            inputProps={{
              maxLength: 2000
            }}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mb={2} mt={1}>
        <FormControl variant="standard" fullWidth>
          <InputLabel
            id="demo-simple-select-standard-label"
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
          />
          <Autocomplete
            className="customNamePicker"
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            disablePortal
            multiple
            id="demo-simple-select-standard-label"
            options={actionUsersList}
            autoComplete
            // for filtering the autocomplete list with atleast 3 characters
            filterOptions={(options: Array<any>, state: any) => {
              let filteredOption: any = [];
              filteredOption = options.filter((item: any) => {
                if (state?.inputValue.length >= 3) {
                  if (
                    item.toLowerCase() === state?.inputValue.toLowerCase() ||
                    item.toLowerCase().includes(state?.inputValue.toLowerCase())
                  ) {
                    return item;
                  }
                }
              });
              return filteredOption;
            }}
            renderTags={(value: readonly any[], getTagProps) =>
              value.map((option: any, index: number) => (
                <div key={index} className="autoCompleteChip">
                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                </div>
              ))
            }
            onChange={(event, newValue) => {
              setDisableSubmit(false);
              if (edit) {
                setUpdateData({ ...updateData, action_assigned_to: newValue });
              } else {
                setCreateData({ ...createData, action_assigned_to: newValue });
              }
            }}
            value={edit ? updateData.action_assigned_to : createData.action_assigned_to}
            renderInput={params => (
              <TextField
                error={false}
                {...params}
                label="Action Assigned To"
                placeholder="Please enter initial 3 characters of the name for user assignment"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.action_req === false
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            inputFormat={dateFormat}
            label="Action Due Date"
            value={preferedFormatForDatePicker(edit ? updateData.action_due : createData.action_due)}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, action_due: null });
                setUpdateData({ ...updateData, action_due: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, action_due: getServerDateOrInvalid(newValue) });
                setUpdateData({ ...updateData, action_due: getServerDateOrInvalid(newValue) });
              }
              //Action Due date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setAcDueDateIssue(true);
              } else {
                setAcDueDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={acDueDateIssue ? 'Invalid Date' : ''}
                helperText={acDueDateIssue ? 'Invalid Date' : ''}
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.action_req === undefined ||
                  updateData.action_req === 'No' ||
                  ((filterActionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !pdUpdateOtherPermission) ||
                  updateData.action_req === false ||
                  !(deviationLogPermissions.updateAction || deviationLogPermissions.updateOther)
                : createData.action_req === undefined || createData.action_req === 'No'
            }
            disableFuture
            inputFormat={dateFormat}
            label="Date of Action completion"
            value={preferedFormatForDatePicker(
              edit ? updateData.action_completion_dt : createData.action_completion_dt
            )}
            minDate={null}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, action_completion_dt: null });
                setUpdateData({ ...updateData, action_completion_dt: null });
              }
              if (newValue !== null) {
                setCreateData({
                  ...createData,
                  action_completion_dt: getServerDateOrInvalid(newValue)
                });
                setUpdateData({
                  ...updateData,
                  action_completion_dt: getServerDateOrInvalid(newValue)
                });
                //action date inline error message
                if (new Date(newValue).toLocaleDateString('en-CA') > new Date().toLocaleDateString('en-CA')) {
                  setActionDateIssue(true);
                } else {
                  setActionDateIssue(false);
                }
              } else {
                //restrict action date auto reload
                setCreateData({
                  ...createData,
                  action_completion_dt: null
                });
                setUpdateData({
                  ...updateData,
                  action_completion_dt: null
                });
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                required={edit ? updateData.action_taken : createData.action_taken}
                error={
                  (edit
                    ? updateData.action_completion_dt
                      ? false
                      : submit
                      ? updateData.action_taken
                        ? true
                        : false
                      : false
                    : createData.action_completion_dt
                    ? false
                    : submit
                    ? createData.action_taken
                      ? true
                      : false
                    : false) ||
                  actionDateIssue ||
                  daError
                }
                helperText={
                  (
                    edit
                      ? updateData.action_completion_dt
                        ? false
                        : submit
                        ? updateData.action_taken
                          ? true
                          : false
                        : false
                      : createData.action_completion_dt
                      ? false
                      : submit
                      ? createData.action_taken
                        ? true
                        : false
                      : false
                  )
                    ? 'Required'
                    : actionDateIssue
                    ? 'Invalid or Future date entered'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          disabled={
            edit
              ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                (updateData.created_by !== user && !pdUpdateOtherPermission)
              : false
          }
          control={<Checkbox name="decision_req" />}
          label="Decisions Required?"
          checked={
            edit
              ? updateData.decision_req === 'Yes' || updateData.decision_req === true
              : createData.decision_req === 'Yes'
          }
          onChange={handleCheckBoxChanged}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            name="decision"
            label="Decisions"
            variant="standard"
            value={edit ? updateData.decision : createData.decision}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            required={edit ? updateData.decision_comp_dt : createData.decision_comp_dt}
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  ((filterDecisionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !pdUpdateOtherPermission) ||
                  updateData.decision_req === false ||
                  !(deviationLogPermissions.updateDecision || deviationLogPermissions.updateOther)
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            error={
              (edit
                ? updateData.decision_update
                  ? false
                  : submit
                  ? updateData.decision_comp_dt
                    ? true
                    : false
                  : false
                : createData.decision_update
                ? false
                : submit
                ? createData.decision_comp_dt
                  ? true
                  : false
                : false) || duError
            }
            helperText={
              (
                edit
                  ? updateData.decision_update
                    ? false
                    : submit
                    ? updateData.decision_comp_dt
                      ? true
                      : false
                    : false
                  : createData.decision_update
                  ? false
                  : submit
                  ? createData.decision_comp_dt
                    ? true
                    : false
                  : false
              )
                ? 'Required'
                : ''
            }
            name="decision_update"
            label="Decision Update"
            variant="standard"
            value={edit ? updateData.decision_update : createData.decision_update}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mb={2} mt={1}>
        <FormControl variant="standard" fullWidth>
          <InputLabel
            id="demo-simple-select-standard-label"
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
          >
            {/* Decision Assigned To */}
          </InputLabel>
          <Autocomplete
            className="customNamePicker"
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            disablePortal
            multiple
            id="demo-simple-select-standard-label"
            options={decisionUserList}
            autoComplete
            // for filtering the autocomplete list with atleast 3 characters
            filterOptions={(options: Array<any>, state: any) => {
              let filteredOption: any = [];
              filteredOption = options.filter((item: any) => {
                if (state?.inputValue.length >= 3) {
                  if (
                    item.toLowerCase() === state?.inputValue.toLowerCase() ||
                    item.toLowerCase().includes(state?.inputValue.toLowerCase())
                  ) {
                    return item;
                  }
                }
              });
              return filteredOption;
            }}
            renderTags={(value: readonly any[], getTagProps) =>
              value.map((option: any, index: number) => (
                <div key={index} className="autoCompleteChip">
                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                </div>
              ))
            }
            onChange={(_, newValue) => {
              setDisableSubmit(false);
              if (edit) {
                setUpdateData({ ...updateData, decision_assigned_to: newValue });
              } else {
                setCreateData({ ...createData, decision_assigned_to: newValue });
              }
            }}
            value={edit ? updateData.decision_assigned_to : createData.decision_assigned_to}
            renderInput={params => (
              <TextField
                error={false}
                {...params}
                label="Decision Assigned To"
                placeholder="Please enter initial 3 characters of the name for user assignment"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                  (updateData.created_by !== user && !pdUpdateOtherPermission) ||
                  updateData.decision_req === false
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            inputFormat={dateFormat}
            label="Decision Due Date"
            value={preferedFormatForDatePicker(edit ? updateData.decision_due_dt : createData.decision_due_dt)}
            minDate={null}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, decision_due_dt: null });
                setUpdateData({ ...updateData, decision_due_dt: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, decision_due_dt: getServerDateOrInvalid(newValue) });
                setUpdateData({
                  ...updateData,
                  decision_due_dt: getServerDateOrInvalid(newValue)
                });
              }
              //Decision Due date inline error message
              if (newValue && String(newValue.$d) === 'Invalid Date') {
                setDcDueDateIssue(true);
              } else {
                setDcDueDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={dcDueDateIssue ? 'Invalid Date' : ''}
                helperText={dcDueDateIssue ? 'Invalid Date' : ''}
                name="decision_due_dt"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            ref={componentRef}
            disabled={
              edit
                ? updateData.decision_req === undefined ||
                  updateData.decision_req === 'No' ||
                  ((filterDecisionUsers.length > 0 ? false : true) &&
                    issueCreatedUser !== user &&
                    !pdUpdateOtherPermission) ||
                  updateData.decision_req === false ||
                  !(deviationLogPermissions.updateDecision || deviationLogPermissions.updateOther)
                : createData.decision_req === undefined || createData.decision_req === 'No'
            }
            disableFuture
            inputFormat={dateFormat}
            label="Date of Decision completion"
            value={preferedFormatForDatePicker(edit ? updateData.decision_comp_dt : createData.decision_comp_dt)}
            minDate={null}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setCreateData({ ...createData, decision_comp_dt: null });
                setUpdateData({ ...updateData, decision_comp_dt: null });
              }
              if (newValue !== null) {
                setCreateData({
                  ...createData,
                  decision_comp_dt: getServerDateOrInvalid(newValue)
                });
                setUpdateData({
                  ...updateData,
                  decision_comp_dt: getServerDateOrInvalid(newValue)
                });
                //decision date inline error message
                if (new Date(newValue).toLocaleDateString('en-CA') > new Date().toLocaleDateString('en-CA')) {
                  setDecisionDateIssue(true);
                } else {
                  setDecisionDateIssue(false);
                }
              } else {
                //restrict decision date auto reload
                setCreateData({
                  ...createData,
                  decision_comp_dt: null
                });
                setUpdateData({
                  ...updateData,
                  decision_comp_dt: null
                });
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                required={edit ? updateData.decision_update : createData.decision_update}
                error={
                  (edit
                    ? updateData.decision_comp_dt
                      ? false
                      : submit
                      ? updateData.decision_update
                        ? true
                        : false
                      : false
                    : createData.decision_comp_dt
                    ? false
                    : submit
                    ? createData.decision_update
                      ? true
                      : false
                    : false) ||
                  decisionDateIssue ||
                  ddError
                }
                helperText={
                  (
                    edit
                      ? updateData.decision_comp_dt
                        ? false
                        : submit
                        ? updateData.decision_update
                          ? true
                          : false
                        : false
                      : createData.decision_comp_dt
                      ? false
                      : submit
                      ? createData.decision_update
                        ? true
                        : false
                      : false
                  )
                    ? 'Required'
                    : decisionDateIssue
                    ? 'Invalid or Future date entered'
                    : ''
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      {deviationLevel == 'SPONSOR' ? (
        <>
          <Grid item xs={6} className="withDatePicker w100">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">PD Identification Method Options</InputLabel>
              <Select
                MenuProps={menuProps}
                disabled={
                  edit
                    ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                      (updateData.created_by !== user && !pdUpdateOtherPermission)
                    : false
                }
                labelId="demo-simple-select-standard-label"
                name="pd_identification_options"
                value={edit ? updateData.pd_identification_options : createData.pd_identification_options}
                onChange={handleChange}
                label="PD Identification Method Options"
              >
                {pdIdentification?.map((item: any) => {
                  return (
                    <MenuItem key={item.id} value={item.code_list_value}>
                      {`${item.code_list_value_code}-${item.code_list_value}`}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} className="withDatePicker w100">
            <FormControl variant="standard" fullWidth>
              <InputLabel id="demo-simple-select-standard-label">Action Taken for Analysis</InputLabel>
              <Select
                MenuProps={menuProps}
                disabled={
                  edit
                    ? (!pdUpdatePermission && !pdUpdateOtherPermission) ||
                      (updateData.created_by !== user && !pdUpdateOtherPermission)
                    : false
                }
                labelId="demo-simple-select-standard-label"
                name="action_taken_analysis"
                value={edit ? updateData.action_taken_analysis : createData.action_taken_analysis}
                onChange={handleChange}
                label="Action Taken for Analysis"
              >
                {analysis?.map((item: any) => {
                  return (
                    <MenuItem key={item.id} value={item.code_list_value}>
                      {`${item.code_list_value_code}-${item.code_list_value}`}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};

export default React.memo(AddandUpdateProtocolDeviation);
